module.exports = __webpack_public_path__ + "img/header-logo.71144a08.png";